<div style="width: 100%;" class="page-content flex flex-col gap-2 common_style px-4 py-2 relative">
  <div class="switch_flex has_side_menu flex-1 flex flex-col lg:flex-row gap-2 min-h-0">
    <div #TableSizeObsContainer style="margin: 8px 4px; padding: 8px 8px 5px;overflow-x: auto; position: relative; flex: 1; display: flex; flex-direction: row;" class="card">
      <mat-tab-group [(selectedIndex)]="selectedTabIdx" (selectedTabChange)="tabChange($event)" style="flex: 1;">
        <mat-tab>
          <ng-template mat-tab-label>
            <fa-icon style="font-size: 16px" [icon]="faWrench"></fa-icon>
          </ng-template>
          <div class="tab_body flex_row" style="position: relative; margin-top: 6px; overflow-x: auto; max-width: 100%; height: 100%; width: 100%; padding-bottom: 3px; display: flex; flex-direction: row;">
            <ag-grid-angular class="ag-theme-quartz grid_table" [rowData]="shownTickets"
                             [theme]="hawkTheme" [loadThemeGoogleFonts]="true"
                             [defaultColDef]="defaultColDef" [columnDefs]="ticketColDefs" [rowClassRules]="rowClassRules"
                             [rowSelection]="'multiple'" [tooltipShowDelay]=".2" [autoSizePadding]="0" [autoSizeStrategy]="autoSizeStrategy"
                             [localeText]="locale" [sideBar]="sideBarOptions" [rowMultiSelectWithClick]="true"
                             [initialState]="initialTicketState"
                             [getRowId]="getTicketRowId"
                             [suppressHorizontalScroll]="true"
                             (gridReady)="onTicketGridReady($event)" (selectionChanged)="onTicketSelectionChanged()">
            </ag-grid-angular>
          </div>
        </mat-tab>
        <mat-tab>
          <ng-template mat-tab-label>
            <fa-icon style="font-size: 16px" [icon]="faBox"></fa-icon>
          </ng-template>
          <div class="tab_body flex_row" style="position: relative; margin-top: 6px; overflow-x: auto; max-width: 100%; height: 100%; width: 100%; padding-bottom: 3px; display: flex; flex-direction: row;">
            <ag-grid-angular class="ag-theme-quartz grid_table" [rowData]="shownMaterialTickets"
                             [theme]="hawkTheme" [loadThemeGoogleFonts]="true"
                             [defaultColDef]="defaultColDef" [columnDefs]="ticketColDefs" [rowClassRules]="rowClassRules"
                             [rowSelection]="'multiple'" [tooltipShowDelay]=".2" [autoSizePadding]="0" [autoSizeStrategy]="autoSizeStrategy"
                             [localeText]="locale" [sideBar]="sideBarOptions" [rowMultiSelectWithClick]="true"
                             [initialState]="initialMaterialTicketState"
                             [getRowId]="getTicketRowId"
                             [suppressHorizontalScroll]="true"
                             (gridReady)="onMaterialTicketGridReady($event)" (selectionChanged)="onMaterialTicketSelectionChanged()">
            </ag-grid-angular>
          </div>
        </mat-tab>
        <mat-tab>
          <ng-template mat-tab-label>
            <fa-icon style="font-size: 16px" [icon]="faUser"></fa-icon>
          </ng-template>
          <div class="tab_body" style="position: relative; margin-top: 6px; overflow-x: auto; max-width: 100%; height: 100%; width: 100%; padding-bottom: 3px; display: flex; flex-direction: row; transition: padding-left .4s ease-in-out;" [style.padding-left]="selectedTabIdx == 2 ? 'calc(12px + 80%)' : '0'">
            <ag-grid-angular style="flex: 1;" class="ag-theme-quartz grid_table" [rowData]="shownTechnicians"
                             [theme]="hawkTheme" [loadThemeGoogleFonts]="true"
                             [defaultColDef]="defaultColDef" [columnDefs]="technicianColDefs" [rowClassRules]="rowClassRules"
                             [rowSelection]="'single'" [autoSizeStrategy]="autoSizeStrategy" [localeText]="locale"
                             [sideBar]="sideBarOptions" [rowMultiSelectWithClick]="true"
                             [initialState]="initialTechnicianState"
                             (gridReady)="onTechnicianGridReady($event)" (selectionChanged)="onTechnicianSelectionChanged()"
                             (rowDataUpdated)="onTechnicianRowDataUpdate()"
            >
            </ag-grid-angular>
          </div>
        </mat-tab>
      </mat-tab-group>
      <div id="filter_container">
        <div class="filter_collection" [ngClass]="selectedTabIdx == 0 ? 'shown': 'hidden'">
          <section class="flex_row" style="border: none; margin-left: 0; margin-right: 8px; max-width: 240px; margin-bottom: 0; position: relative; transform: translateY(-5px)" [ngClass]="selectedTicketIds.length == 0 ? 'hidden' : ''">
            <h2 style="background-color: rgba(0,0,0,0); color: gray;">Auswahl: {{selectedTicketIds.length}} Ticket(s)</h2>
            <div class="flex_row" style="height: 30px; width: 100%; position: relative;">
              <button class="bm-btn bm-btn-sm bm-btn-secondary my-auto" style="color: white; margin-left: 2px;" [disabled]="!selectedTicketIds.length" (click)="openPlanningAssistant(true)">
                Im PA öffnen
              </button>
            </div>
          </section>
          <section style="flex-wrap: wrap; flex: 1; border: none; margin-left: 0; margin-right: 8px; margin-bottom: 0; position: relative; transform: translateY(-5px)" class="flex_row">
            <h2 style="background-color: rgba(0,0,0,0); color: gray;">Projektauswahl</h2>
            <div style="height: 30px; width: 100%; position: relative;">
              <div class="abs_bounds section_scrollbar" style="overflow-x: auto; bottom: -12px; left: -10px; right: -10px; padding: 0 10px;">
                <div class="flex_row" style="width: fit-content; flex-wrap: nowrap;">
                  <div style="border-right: 1px solid black; margin-right: 4px;">
                    <div class="fast_filter" [ngClass]="selectedProjects == 'all' ? 'selected' : ''" (click)="selectAllProjects()">
                      <div style="margin: auto 6px;">
                        Alle
                      </div>
                    </div>
                  </div>
                  <div class="fast_filter"
                       [ngClass]="(selectedProjects == 'all' || selectedProjects.includes(open_project.project_name)) ? 'selected' : ''"
                       *ngFor="let open_project of openProjects" (click)="clickProject(open_project.project_name)"
                       [style.color]="open_project.unplanned_tickets.length == 0 ? 'gray' : 'black'"
                       [style.background-color]="open_project.unplanned_tickets.length == 0 ? 'lightgray' : 'white'"
                  >
                    <div style="margin: auto 0; display: inline-flex; flex-direction: row;">
                      {{open_project.project_name}}
                      <ng-container *ngIf="open_project.unplanned_tickets.length == 0">
                        <fa-icon style="color: rgb(0,128,0);" [icon]="faCheck"></fa-icon>
                      </ng-container>
                      <ng-container *ngIf="open_project.unplanned_tickets.length != 0">
                        ({{open_project.unplanned_tickets.length}})
                      </ng-container>
                      <div class="single_selection green_on_hover"
                           [tooltip]="'Zur Auswahl hinzufügen'"
                           *ngIf="(selectedProjects != 'all' && !selectedProjects.includes(open_project.project_name))"
                           (click)="$event.stopPropagation();addProjectToSelection(open_project.project_name)">
                        <fa-icon style="margin: auto;" [icon]="faPlusCircle"></fa-icon>
                      </div>
                      <div class="single_selection red_on_hover" [ngClass]="selectedProjects.length == 1 ? 'disabled' : ''"
                           [tooltip]="'Von Auswahl entfernen'"
                           *ngIf="(selectedProjects == 'all' || selectedProjects.includes(open_project.project_name))"
                           (click)="$event.stopPropagation();removeProjectFromSelection(open_project.project_name)">
                        <fa-icon style="margin: auto;" [icon]="faMinusCircle"></fa-icon>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section class="review-filter flex_row">
            <h2 style="background:transparent; color:gray;">Wiedervorlage</h2>
            <div class="fast_filter_wrapper" style="display:inline-flex; gap:6px;">

              <!-- Ohne Wiedervorlage -->
              <div class="fast_filter" [ngClass]="selectedReviewFilter==='off' ? 'selected' : ''">
                <div style="margin:auto 0; display:inline-flex; flex-direction:row;" (click)="selectReviewFilter('off')">
                  Aus
                </div>
              </div>

              <!-- Wiedervorlage erreicht -->
              <div class="fast_filter" [ngClass]="selectedReviewFilter==='planned' ? 'selected' : ''">
                <div style="margin:auto 0; display:inline-flex; flex-direction:row;" (click)="selectReviewFilter('planned')">
                  Geplant
                </div>
              </div>

            </div>
          </section>
          <div class="bm-join">
            <input type="text" class="bm-join-item bm-input" style="margin: auto 0 auto 6px" (input)="ticketQuickSearchChanged($event)" placeholder="Schnellfilter" />
            <a class="bm-join-item bm-btn bm-btn-primary bm-btn-square" style="margin: auto 0" [cdkMenuTriggerFor]="ticketMenu">
              <i class="fa fa-ellipsis-v"></i>
            </a>
            <ng-template #ticketMenu>
              <ul
                cdkMenu
                class="bm-menu bm-dropdown-content bg-primary text-primary-content rounded-box z-1 w-52 shadow-sm p-0 m-0 mt-1"
              >
                <li class="bm-divider m-0 p-0 h-0 bm-divider-secondary"></li>
                <li>
                  <a (click)="saveTicketFilterState()">
                    <i class="fa fa-save"></i>
                    Config speichern
                  </a>
                </li>
                <li>
                  <a (click)="deleteTicketFilterState()">
                    <i class="fa fa-ban"></i>
                    Config löschen
                  </a>
                </li>
              </ul>
            </ng-template>
          </div>
        </div>
        <div class="filter_collection" [ngClass]="selectedTabIdx == 1 ? 'shown': 'hidden'">
          <div style="flex: 1"></div>
          <section class="review-filter flex_row">
            <h2 style="background:transparent; color:gray;">Wiedervorlage</h2>
            <div class="fast_filter_wrapper" style="display:inline-flex; gap:6px;">
              <div class="fast_filter" [ngClass]="selectedMaterialReviewFilter==='off' ? 'selected' : ''">
                <div style="margin:auto 0; display:inline-flex; flex-direction:row;" (click)="selectMaterialReviewFilter('off')">
                  Aus
                </div>
              </div>
              <div class="fast_filter" [ngClass]="selectedMaterialReviewFilter==='planned' ? 'selected' : ''">
                <div style="margin:auto 0; display:inline-flex; flex-direction:row;" (click)="selectMaterialReviewFilter('planned')">
                  Geplant
                </div>
              </div>
            </div>
          </section>
          <div class="bm-join">
            <input type="text" class="bm-join-item bm-input" style="margin: auto 0 auto 6px" (input)="materialTicketQuickSearchChanged($event)" placeholder="Schnellfilter" />
            <a class="bm-join-item bm-btn bm-btn-primary bm-btn-square" style="margin: auto 0" [cdkMenuTriggerFor]="materialTicketMenu">
              <i class="fa fa-ellipsis-v"></i>
            </a>
            <ng-template #materialTicketMenu>
              <ul
                cdkMenu
                class="bm-menu bm-dropdown-content bg-primary text-primary-content rounded-box z-1 w-52 shadow-sm p-0 m-0 mt-1"
              >
                <li class="bm-divider m-0 p-0 h-0 bm-divider-secondary"></li>
                <li>
                  <a (click)="saveMaterialTicketFilterState()">
                    <i class="fa fa-save"></i>
                    Config speichern
                  </a>
                </li>
                <li>
                  <a (click)="deleteMaterialTicketFilterState()">
                    <i class="fa fa-ban"></i>
                    Config löschen
                  </a>
                </li>
              </ul>
            </ng-template>
          </div>
        </div>
        <div class="filter_collection" [ngClass]="selectedTabIdx == 2 ? 'shown': 'hidden'">
          <select class="bm-select" style="margin: auto 0 auto auto;" [(ngModel)]="technicianGroupFilter" (ngModelChange)="updateShownTechnicians()">
            <option value="bentomax">
              Bentomax-Techniker
            </option>
            <option value="plus_external_with_operations">
              + Externe mit Aufträgen
            </option>
            <option value="all">
              Alle
            </option>
          </select>
          <div class="bm-join">
            <input type="text" class="bm-join-item bm-input" style="margin: auto 0 auto 6px" (input)="technicianQuickSearchChanged($event)" placeholder="Schnellfilter" />
            <a class="bm-join-item bm-btn bm-btn-primary bm-btn-square" style="margin: auto 0" [cdkMenuTriggerFor]="technicianMenu">
              <i class="fa fa-ellipsis-v"></i>
            </a>
            <ng-template #technicianMenu>
              <ul
                cdkMenu
                class="bm-menu bm-dropdown-content bg-primary text-primary-content rounded-box z-1 w-52 shadow-sm p-0 m-0 mt-1"
              >
                <li class="bm-divider m-0 p-0 h-0 bm-divider-secondary"></li>
                <li>
                  <a (click)="saveTechnicianFilterState()">
                    <i class="fa fa-save"></i>
                    Config speichern
                  </a>
                </li>
                <li>
                  <a (click)="deleteTechnicianFilterState()">
                    <i class="fa fa-ban"></i>
                    Config löschen
                  </a>
                </li>
              </ul>
            </ng-template>
          </div>
        </div>
      </div>
      <!-- Linkes Panel: Karte (absolute, auf Tabellen-Ebene, 80% Breite) -->
      <div class="overflow-hidden"
           style="position: absolute; left: 8px; bottom: 5px; z-index: 5; transition: width .4s ease-in-out; top: 56px;"
           [style.width]="selectedTabIdx == 2 ? '80%' : '0'">
        <div class="flex_col side_map" style="width: 100%; height: 100%; position: relative; padding-top: 6px;">
          <!-- Rechter Steuerungsbereich: Kartenfilter + Tageseinsätze -->
          <div style="position: absolute; top: 12px; right: 12px; bottom: 12px; z-index: 25; display: inline-flex; flex-direction: column; pointer-events: none;">
            <!-- Kartenfilter -->
            <div class="flex_row" style="background-color: rgba(255,255,255,.5); backdrop-filter: blur(4px); pointer-events: all;">
              <mat-form-field style="margin-left: auto;" class="outline-small no-subscript" [appearance]="'outline'" (click)="$event.stopPropagation()">
                <mat-label>Techniker</mat-label>
                <mat-select [(ngModel)]="mapTechnicianFilter" (ngModelChange)="updateTechnicianMapDisplayUnits();">
                  <mat-option value='with_tour'>Mit Tour</mat-option>
                  <mat-option value='not_absent'>Anwesend</mat-option>
                  <mat-option value='all'>Alle</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field class="outline-small no-subscript" [appearance]="'outline'" (click)="$event.stopPropagation()">
                <mat-label>Touren</mat-label>
                <mat-select [(ngModel)]="mapTourFilter" (ngModelChange)="updateTourDisplayUnits()">
                  <mat-option value='selected'>In Tabelle ausgewählt</mat-option>
                  <mat-option value='all'>Alle</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <!-- Tageseinsätze: Overlay unter den Filtern, gleiche Breite -->
            <div style="margin-top: 8px; flex: 1; min-height: 0; overflow: hidden; transition: transform .4s ease-in-out; background-color: rgba(255,255,255,.55); backdrop-filter: blur(6px); border: 1px solid rgba(200,200,200,.5); border-radius: 4px; padding: 10px; display: flex; flex-direction: column; pointer-events: all;"
                 [style.transform]="selectedTechnician ? 'translateX(0)' : 'translateX(calc(100% + 12px))'">
              <ng-container *ngIf="selectedTechnician">
                <div class="flex_row">
                  <h5 style="margin: 0; font-size: .95rem;">Tageseinsätze {{selectedTechnician.full_name}}</h5>
                  <fa-icon style="margin: auto 0 auto auto; cursor: pointer;" [icon]="faWindowClose" (click)="unselectTechnician()"></fa-icon>
                </div>
                <hr style="margin: 6px 0;">
                <hawk-route-visualization
                        style="flex: 1; overflow-y: auto;"
                        [nodes]="routeVisualizationNodes"
                ></hawk-route-visualization>
              </ng-container>
            </div>
          </div>
          <div style="flex: 1; border: 1px solid lightgray;" class="map_container">
            <hawk-dashboard-map *ngIf="technicianTabWasSelected" [navigation]="mapNavigation" [mapDisplayUnits]="mapDisplayUnits" [selectedTabIndex]="selectedTabIdx"></hawk-dashboard-map>
          </div>
          <section style="position:absolute; bottom: 6px; left: -4px; z-index: 20; background-color: rgba(255,255,255,.4); backdrop-filter: blur(4px);">
            <h2 style="background-color: rgba(255,255,255,.4); backdrop-filter: blur(4px); display: flex; flex-direction: row;">
              <div [tooltip]="selectedTechnician ? 'Ausgewählter Techniker: ' + selectedTechnician.full_name : ''">
                <fa-icon [style.color]="(selectedTechnician?.tour?.color && selectedTechnician?.tour?.operations.length) ? selectedTechnician?.tour?.color : '#3379b6'"
                         class="hover_icon" [ngClass]="selectedTechnician ? '' : 'disabled'" [icon]="faUser"
                ></fa-icon>
              </div>
              <div style="position: relative;" [tooltip]="selectedTicketIds.length ? 'Ausgewählte Tickets: ' + selectedTicketIds.length : ''">
                <fa-icon style="color: #3379b6;" class="hover_icon"
                         [ngClass]="selectedTicketIds.length ? '' : 'disabled'" [icon]="faWrench"
                ></fa-icon>
                <div *ngIf="selectedTicketIds.length" style="position: absolute; bottom: -4px; right: -2px; z-index: 2; pointer-events: none; font-size: .65rem; font-weight: bold; background-color: rgba(255,255,255,.6); border-radius: 2px;">
                  {{selectedTicketIds.length}}
                </div>
              </div>
            </h2>
            <button class="bm-btn bm-btn-sm bm-btn-secondary" [disabled]="!selectedTicketIds.length && !selectedTechnician" (click)="openPlanningAssistant()">
              Auswahl im PA öffnen
            </button>
          </section>
        </div>
      </div>
    </div>

  </div>
  <div class="relative flex flex-col" [class.mb-10]="capacityBarsCollapsed" style="padding: 0 12px;">
    <div class="flex items-center cursor-pointer px-3 py-1.5 select-none bg-base-100 border border-base-300 shadow-sm"
         [ngClass]="capacityBarsCollapsed ? 'rounded' : 'rounded-t border-b-0'"
         (click)="capacityBarsCollapsed = !capacityBarsCollapsed">
      <span class="text-sm font-semibold">Kapazitätsübersicht</span>
      <fa-icon class="ml-auto opacity-60 transition-transform duration-300 ease-in-out"
               [class.rotate-180]="!capacityBarsCollapsed"
               [icon]="faChevronDown"></fa-icon>
    </div>
    <div class="grid border border-base-300 bg-base-100 rounded-b shadow-sm"
         [class.border-t-0]="!capacityBarsCollapsed"
         style="transition: grid-template-rows .4s ease-in-out"
         [style.grid-template-rows]="capacityBarsCollapsed ? '0fr' : '1fr'">
      <div class="overflow-hidden min-h-0">
        <hawk-capacity-bars
                [barData]="technicianBarData"
                [options]="capacityBarOptions"
                [filter]="capacityBarsFilter"
                [deadlines]="deadlineNow ? [deadlineNow] : []"
                [labels]="[{color: 'rgb(0,128,0)', description: 'Unterwegs'}, {color: 'rgb(253,0,0)', description: 'Nicht genutzt'}, {color: 'rgb(255,132,132)', description: 'Freie Zeit'}, {color: 'lightgray', description: 'Abwesenheit'}]"
                [measureUnit]="':00'"
                [unitAmountEnd]="unitAmountEnd"
                [unitAmountInterSteps]="6"
                [unitAmountStart]="unitAmountStart"
                (clickBarEvent)="selectTechnicianInTable(shownTechnicians[$event])"
                (changeOptionEvent)="changeBarOption($event)"
        />
      </div>
    </div>
  </div>
  <div class="absolute bg-primary p-2 slide_hover bg-base-100"
       style="bottom: 0; left: 28px; z-index: 50; width: 320px; border-top-right-radius: 4px; border-bottom-left-radius: 4px; border-bottom-right-radius: 4px">
    <div class="absolute bg-primary p-2"
         style="left: 0; font-size: 1rem; bottom: 100%; color: white; border-top-left-radius: 4px; border-top-right-radius: 4px; border-bottom:  1px solid lightgray;">
      {{parseDateToDayString(selectedDate())}}
    </div>
    <mat-card class="demo-inline-calendar-card">
      <mat-calendar [(selected)]="selectedDate"></mat-calendar>
    </mat-card>
  </div>
</div>

@if (showTicketReviewDialogForm) {
  <dialog class="bm-modal" open (document:keydown.escape)="closeReviewDialog()">
    <div class="bm-modal-box max-h-[80vh] overflow-y-auto w-full max-w-2xl" style="display: flex; flex-direction: column;">
      <h4 class="font-bold text-lg mb-2">Ticket-Wiedervorlage</h4>
      <div class="bm-alert bm-alert-info bm-alert-soft mb-4">
        <div>
          <h4 class="font-bold">Info</h4>
          <div class="text-xs mb-2">
            Mit der Wiedervorlage können Tickets für einen bestimmten Termin zurückgestellt werden. Sie verschwinden bis dahin aus der Liste und erscheinen zum gesetztem Zeitpunkt wieder automatisch.
          </div>
        </div>
      </div>
      @if (hasActiveReview()) {
        <div class="bm-alert bm-alert-warning bm-alert-soft mb-4">
          <div>
            <h4 class="font-bold">Aktive Wiedervorlage</h4>
            <div class="text-xs">
              Dieses Ticket hat bereits eine aktive Wiedervorlage bis zum {{ reviewDialogTicket.review.date | date:'dd.MM.yyyy HH:mm' }} Uhr.
              Sie können die Wiedervorlage im hier ändern oder zurücksetzen.
              <br>
              Grund: {{ reviewDialogTicket.review.reason }}
            </div>
          </div>
        </div>
      }
      <div class="flex-grow-1">
        <form [formGroup]="showTicketReviewDialogForm">
          <fieldset class="bm-fieldset">
            <label class="bm-fieldset-label">Wiedervorlage-Datum</label>
          </fieldset>
          <div class="flex_row">
            <input
              class="bm-input"
              type="text"
              mwlFlatpickr
              formControlName="review_date"
              [locale]="'de'"
              [options]="datePickerConfig"
              [convertModelValue]="true"
              style="width: 150px;"
            />
            <button class="bm-btn bm-btn-sm my-auto ms-1" (click)="setReviewDateTomorrow()">Morgen</button>
            <button class="bm-btn bm-btn-sm my-auto ms-1" (click)="setReviewDateIn3Days()">3 Tage</button>
            <button class="bm-btn bm-btn-sm my-auto ms-1" (click)="setReviewDateIn1Week()">Eine Woche</button>
          </div>
          <fieldset class="bm-fieldset">
            <label class="bm-fieldset-label">Grund</label>
          </fieldset>
          <textarea
            class="bm-textarea w-full resize-y"
            formControlName="review_reason"
            rows="3"
            maxlength="500"
            placeholder="Kurzer Hinweis zur Wiedervorlage… (wird im Logbucheintrag gespeichert)"
          ></textarea>
        </form>
      </div>
      <div class="bm-modal-action justify-between">
        @if (hasActiveReview()) {
          <button class="bm-btn bm-btn-error" (click)="resetTicketReview()">Wiedervorlage zurücksetzen</button>
        } @else {
          <div></div>
        }
        <div class="flex gap-2">
          <button class="bm-btn" (click)="closeReviewDialog()">Abbrechen</button>
          <button class="bm-btn bm-btn-primary" (click)="saveTicketReview();" [disabled]="!showTicketReviewDialogForm?.valid">Speichern</button>
        </div>
      </div>
    </div>
  </dialog>
}
